export default __webpack_public_path__ + "static/media/frg--indoor-pool.b363479c.png";